import { render, staticRenderFns } from "./HomeV2.vue?vue&type=template&id=ac12ce80&scoped=true&"
import script from "./HomeV2.vue?vue&type=script&lang=js&"
export * from "./HomeV2.vue?vue&type=script&lang=js&"
import style0 from "./HomeV2.vue?vue&type=style&index=0&id=ac12ce80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac12ce80",
  null
  
)

export default component.exports